import { HierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import { Grid } from '@gogame/components';

import IOSWarning from './IOSWarning';

const IOSWarningHierarchy = ({ onInvoiceChangeLevel, ios = [], ...props }) => {
  return (
    <HierarchyArea {...props}>
      {({ area }) => {
        return area.data && area.data.length && !ios.length ? (
          <Grid item xs={12}>
            <IOSWarning
              onInvoiceChangeLevel={() => onInvoiceChangeLevel(area.data)}
            />
          </Grid>
        ) : null;
      }}
    </HierarchyArea>
  );
};

export default IOSWarningHierarchy;
